"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const constants_1 = require("../constants");
exports.default = theme => ({
    root: {
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        overflow: 'hidden',
        boxSizing: 'border-box',
        borderWidth: 0,
        appearance: 'none',
        flexShrink: 0,
        cursor: 'default',
        outline: 'none',
        color: theme.indigo3,
        backgroundColor: 'transparent',
        position: 'relative',
        lineHeight: 'inherit',
        '&::before': {
            content: '""',
            position: 'absolute',
            height: constants_1.MIN_TARGET_SIZE,
            top: '50%',
            left: 0,
            right: 0,
            transform: 'translateY(-50%)'
        },
        '&[data-is-warning=true]': {
            color: theme.warningRed
        },
        '&[data-is-muted=true]': {
            color: theme.grey4,
            '&[data-is-warning=true]:hover': {
                color: theme.warningRed
            }
        },
        '&[disabled]': {
            color: theme.grey4,
            '& img': {
                opacity: 0.3
            }
        },
        '&:not([disabled]):hover': {
            cursor: 'pointer'
        }
    },
    prefix: {
        marginRight: 7,
        flexShrink: 0
    },
    suffix: {
        marginLeft: 7,
        flexShrink: 0
    },
    text: {
        color: 'currentColor',
        fontSize: 14,
        fontWeight: 400,
        whiteSpace: 'nowrap',
        ':not([disabled]):hover > &, :focus > &': {
            textDecoration: 'underline'
        },
        '[aria-haspopup="true"] > &::after': {
            content: '"…"'
        }
    }
});
//# sourceMappingURL=pushtext.style.js.map